"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _bs = require("react-icons/bs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputPassword = function InputPassword(_ref) {
  var value = _ref.value,
      name = _ref.name,
      isInvalid = _ref.isInvalid,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      errors = _ref.errors,
      label = _ref.label,
      maxLength = _ref.maxLength,
      showIcon = _ref.showIcon,
      className = _ref.className,
      helperText = _ref.helperText,
      color = _ref.color,
      border = _ref.border,
      backgroundColor = _ref.backgroundColor;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isTypePassword = _useState2[0],
      setIsTypePassword = _useState2[1];

  var borderColor = isInvalid ? 'group-input-search border-search' : 'group-input-search';

  var popover = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover-".concat(name)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Header, {
    as: "h4"
  }, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, {
    style: {
      padding: ' 0.25rem 0.5rem'
    }
  }, helperText && helperText.split('[BR]').map(function (text, idx) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: "text-".concat(idx * 10),
      style: {
        margin: 5
      }
    }, text);
  })));

  var actionButton = function actionButton() {
    setIsTypePassword(!isTypePassword);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styleInput ".concat(className)
  }, label && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    hasValidation: true,
    className: "container-input"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: isTypePassword ? 'password' : 'text',
    autoComplete: "off",
    disabled: disabled,
    placeholder: placeholder,
    value: value === null || value === void 0 ? void 0 : value.trim(),
    name: name,
    isInvalid: isInvalid,
    onChange: function onChange(e) {
      _onChange(e);
    },
    maxLength: maxLength,
    className: "".concat(color, " ").concat(border, " ").concat(backgroundColor)
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control.Feedback, {
    type: "invalid"
  }, errors), showIcon && !disabled && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button-search",
    onClick: actionButton
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup.Text, {
    className: borderColor
  }, isTypePassword ? /*#__PURE__*/_react.default.createElement(_bs.BsFillEyeSlashFill, null) : /*#__PURE__*/_react.default.createElement(_bs.BsFillEyeFill, null)))), helperText && /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    overlay: popover,
    rootClose: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "link",
    style: {
      padding: '0.1rem'
    },
    size: "sm"
  }, /*#__PURE__*/_react.default.createElement(_bs.BsQuestionCircle, null)))));
};

InputPassword.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),
  name: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func,
  isInvalid: _propTypes.default.bool,
  errors: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  showIcon: _propTypes.default.bool,
  maxLength: _propTypes.default.number,
  className: _propTypes.default.string,
  max: _propTypes.default.number,
  min: _propTypes.default.number,
  helperText: _propTypes.default.string,
  color: _propTypes.default.oneOf(['default', 'colorBlue', 'colorGreen', 'colorBlack', 'colorRed', 'colorWhite']),
  backgroundColor: _propTypes.default.oneOf(['default', 'backgroundBlue', 'backgroundGreen']),
  border: _propTypes.default.oneOf(['default', 'transparent'])
};
InputPassword.defaultProps = {
  disabled: false,
  isInvalid: false,
  showIcon: false,
  onChange: function onChange() {},
  maxLength: null,
  label: '',
  errors: '',
  placeholder: '',
  className: '',
  helperText: null,
  hasChanged: false,
  isDecimal: true,
  onBlur: function onBlur() {},
  color: 'default',
  backgroundColor: 'default',
  border: 'default'
};
var _default = InputPassword;
exports.default = _default;